<template>
  <div class="top-right-btn">
    <el-row>
      <el-tooltip class="item" effect="dark" :content="showSearch ? '隐藏搜索' : '显示搜索'" placement="top">
        <el-button size="mini" circle icon="el-icon-search" @click="toggleSearch()" />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <el-button size="mini" circle icon="el-icon-refresh" @click="refresh()" />
      </el-tooltip>
      <el-popover
          style="margin-left: 10px"
          placement="bottom-end"
          title="勾选显示"
          width="120"
          trigger="click">
        <div style="display: flex;flex-direction: column;">
          <el-checkbox :indeterminate="indeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox v-for="(value,key) in columnInfo" :key="key" v-model="value.visible" @change="handleCheckChange">{{value.label}}</el-checkbox>
        </div>
        <template #reference>
          <el-tooltip class="item" effect="dark" content="显隐列" placement="top" v-if="columnInfo" v-show="showColumn">
            <el-button size="mini" circle icon="el-icon-menu"/>
          </el-tooltip>
        </template>
      </el-popover>
    </el-row>
  </div>
</template>

<script>
/**
 * 右边顶部工具栏升级版（主要加入了对 表格固定表头和固定列计算出现的bug进行修复，通过表格重新渲染实现，保持原有版本兼容，因而出现升级版，后续使用该组件）
 * @author PeterLee
 * @since 2022-02-26
 */
export default {
  name: "RightToolbarPlus",
  data() {
    return {
      checkAll:true,
      indeterminate:false
    };
  },
  props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
    columnInfo: {
      type: Object,
    },
    showColumn:{
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 搜索
    toggleSearch() {
      this.$emit("update:showSearch", !this.showSearch);
    },
    // 刷新
    refresh() {
      this.$emit("queryTable");
      //重新渲染表格
      this.$emit("redoTableLayout");
    },
    //处理全选事件
    handleCheckAllChange(val) {
      for(let key in this.columnInfo){
        if(this.columnInfo.hasOwnProperty(key)){
          this.columnInfo[key].visible=val;
        }
      }
      this.indeterminate=false;
      //重新渲染表格
      this.$emit("redoTableLayout");
    },
    //选择改变事件
    handleCheckChange(value) {
      //隐藏个数
      let num=0;
      for(let key in this.columnInfo){
        if(this.columnInfo.hasOwnProperty(key)){
          if(!this.columnInfo[key].visible){
            num++;
          }
        }
      }
      if(value){
        if(num===0){
          this.indeterminate=false;
          this.checkAll=true;
        }else{
          this.checkAll=false;
          this.indeterminate=true;
        }
      }else{
        if(num===Object.keys(this.columnInfo).length){
          this.checkAll=false;
          this.indeterminate=false;
        }else{
          this.checkAll=false;
          this.indeterminate=true;
        }
      }
      //重新渲染表格
      this.$emit("redoTableLayout");
    }
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-transfer__button {
  border-radius: 50%;
  padding: 12px;
  display: block;
  margin-left: 0;
}
::v-deep .el-transfer__button:first-child {
  margin-bottom: 10px;
}
.top-right-btn {
  position: relative;
  float: right;
}
</style>